import React, { useState } from "react";
import { getStatusColor } from "../HotelPage/utils/hotelUtils";
import QuickStatusModal from "../HotelPage/StatusChange/QuickStatusModal";

// Mapping des statuts de features vers les statuts de modules pour réutiliser les mêmes couleurs
const getFeatureStatusColor = (status) => {
  const statusMap = {
    LIVE: "Good",
    PAS_EQUIPE: "À équiper",
    DESEQUIPE: "Warning",
    OFF: "Failed",
  };
  return getStatusColor(statusMap[status] || status);
};

const getFeatureStatusLabel = (status) => {
  switch (status) {
    case "LIVE":
      return "LIVE";
    case "PAS_EQUIPE":
      return "Pas équipé";
    case "DESEQUIPE":
      return "Déséquipé";
    case "OFF":
      return "OFF";
    default:
      return "Non défini";
  }
};

const getFeatureEmoji = (feature) => {
  switch (feature) {
    case "lunishower":
      return "🚿";
    case "greenmiles":
      return "🌱";
    case "lunibutton":
      return "🔘";
    default:
      return "";
  }
};

const getFeatureLabel = (feature) => {
  switch (feature) {
    case "lunishower":
      return "LuniShower";
    case "greenmiles":
      return "GreenMiles";
    case "lunibutton":
      return "LuniButton";
    default:
      return "";
  }
};

const ClickableFeatureStatus = ({ feature, status, hotelId, onStatusChange, compact = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const handleStatusClick = (e) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    setModalPosition({
      top: rect.bottom + scrollTop,
      left: rect.left + scrollLeft,
    });

    setIsModalOpen(true);
  };

  const handleStatusChange = async (newStatus) => {
    try {
      await onStatusChange(hotelId, feature, newStatus);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Erreur lors du changement de statut:", error);
    }
  };

  const displayStatus = status || null;
  const featureLabel = getFeatureLabel(feature);
  
  // Créer un objet "room" factice pour réutiliser QuickStatusModal
  const fakeRoom = {
    id: hotelId,
    status: displayStatus,
    room_nb: featureLabel,
  };

  // Liste des statuts disponibles pour les features (même format que QuickStatusModal)
  const availableStatuses = [
    { value: "LIVE", label: "LIVE", description: "Feature active et opérationnelle", color: "bg-green-100 text-green-800" },
    { value: "PAS_EQUIPE", label: "Pas équipé", description: "Feature non installée", color: "bg-gray-100 text-gray-800" },
    { value: "DESEQUIPE", label: "Déséquipé", description: "Feature retirée", color: "bg-yellow-100 text-yellow-800" },
    { value: "OFF", label: "OFF", description: "Feature désactivée", color: "bg-red-100 text-red-800" },
  ];

  return (
    <>
      <button
        onClick={handleStatusClick}
        className={`
          inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium transition-all duration-150
          ${getFeatureStatusColor(displayStatus)}
          ${compact ? "hover:opacity-80" : "hover:shadow-sm hover:scale-105"}
          cursor-pointer
        `}
        title={`Cliquer pour changer le statut ${featureLabel}`}
      >
        {!compact && <span className="mr-1">{getFeatureEmoji(feature)}</span>}
        <span>{getFeatureStatusLabel(displayStatus)}</span>
        {!compact && (
          <svg className="ml-1 w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        )}
      </button>

      {/* Réutiliser QuickStatusModal avec les statuts des features */}
      <QuickStatusModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        currentStatus={displayStatus} 
        onStatusChange={handleStatusChange} 
        room={fakeRoom}
        position={modalPosition}
        availableStatuses={availableStatuses}
      />
    </>
  );
};

export default ClickableFeatureStatus;
